import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitojaipurtaxi() {



  const cardData =
  {
    keyword: 'Mumbai to Jaipur Taxi ',
    heading: 'Shambhu Cabs: Mumbai to Jaipur Taxi',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Jaipur Taxi services, providing safe, comfortable, and hassle-free travel for families, corporate travelers, business groups, and long-distance commuters heading to Jaipur. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Jaipur with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, professional chauffeurs, and 24/7 booking support, Shambhu Cabs makes long-distance travel convenient, stress-free, and comfortable. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Jaipur taxi services for travelers seeking comfort, safety, punctuality, and a reliable intercity travel experience.',

    top: 'Top Places to Visit in Jaipur with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Amber Fort",
    "description": "Amber Fort, located 11 km from Jaipur city, is a majestic hilltop fort built in 1592 by Raja Man Singh I. The fort showcases a stunning blend of Rajput and Mughal architecture with intricate carvings, mirror work, and sprawling courtyards. Visitors can explore the Sheesh Mahal (Mirror Palace), Diwan-i-Aam, and lush gardens while enjoying panoramic views of Maota Lake. Elephant rides, light-and-sound shows, and cultural performances enhance the experience, making Amber Fort a must-visit heritage site that reflects the grandeur of Jaipur’s royal history."
  },
  {
    "title": "City Palace",
    "description": "City Palace is the royal residence of Jaipur’s Maharajas and a magnificent complex of courtyards, gardens, and buildings blending Rajasthani and Mughal architecture. Built in the 18th century by Maharaja Sawai Jai Singh II, it houses the Chandra Mahal, Mubarak Mahal, and several museums displaying royal artifacts, costumes, manuscripts, and weaponry. The palace provides insights into Jaipur’s regal lifestyle and heritage, while its ornate gates, balconies, and courtyards are popular spots for photography and sightseeing."
  },
  {
    "title": "Hawa Mahal",
    "description": "Hawa Mahal, known as the 'Palace of Winds,' is an iconic five-story pink sandstone structure built in 1799 by Maharaja Sawai Pratap Singh. The lattice windows (jharokhas) allowed royal women to observe street festivals while maintaining privacy. Its unique honeycomb façade, intricate latticework, and architectural symmetry make it a major tourist attraction. The building also offers a small museum and a viewing gallery where visitors can enjoy panoramic views of the city streets below."
  },
  {
    "title": "Jantar Mantar",
    "description": "Jantar Mantar is an astronomical observatory built by Maharaja Sawai Jai Singh II in 1734. It is a UNESCO World Heritage Site and houses a collection of 19 architectural astronomical instruments designed for measuring time, predicting eclipses, and tracking celestial bodies. The massive sundials, geometric structures, and precise scales demonstrate the advanced scientific knowledge of the time. Jantar Mantar is both an educational and visually striking destination for history, science, and architecture enthusiasts."
  },
  {
    "title": "Nahargarh Fort",
    "description": "Nahargarh Fort, perched on the Aravalli hills, was constructed in 1734 to serve as a defense fortification for Jaipur. The fort offers stunning panoramic views of the Pink City and surrounding hills. Visitors can explore its sprawling courtyards, royal chambers, and step gardens. Nahargarh is particularly famous for sunset views, rooftop dining, and historical significance, as it once provided a retreat for the royal family and served as a strategic military base."
  },
  {
    "title": "Jaigarh Fort",
    "description": "Jaigarh Fort, situated on a hill above Amber Fort, is renowned for housing the world’s largest cannon on wheels, the Jaivana Cannon. Built in 1726 by Maharaja Sawai Jai Singh II, the fort was primarily used to protect the palace and the surrounding areas. Its massive walls, watchtowers, underground passages, and armory reflect the military strength and architectural brilliance of the Rajputs. The fort also offers stunning views of Amber Fort, Maota Lake, and the Aravalli ranges."
  },
  {
    "title": "Albert Hall Museum",
    "description": "Albert Hall Museum, located in Ram Niwas Garden, is the oldest museum of Rajasthan and a prime example of Indo-Saracenic architecture. Built in 1887, it houses a rich collection of artifacts including paintings, sculptures, carpets, jewelry, and coins. The museum’s intricate interiors, stained glass, and ornate pillars reflect the grandeur of Jaipur’s architectural style. It serves as an important center for cultural education and heritage preservation, attracting tourists and history enthusiasts alike."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir, also known as Laxmi Narayan Temple, is a modern white marble temple dedicated to Lord Vishnu and Goddess Laxmi. Built by the Birla family, it features beautiful carvings, idols, and a serene atmosphere for meditation and worship. The temple is situated on a hill overlooking the city, offering stunning views of Jaipur. Evening visits are particularly popular when the temple is illuminated, creating a tranquil and spiritual experience for visitors."
  },
  {
    "title": "Galta Ji (Monkey Temple)",
    "description": "Galta Ji, popularly known as the Monkey Temple, is an ancient Hindu pilgrimage site located in the Aravalli hills. The temple complex includes several natural springs, sacred kunds (water tanks), and ornate temples dedicated to Lord Hanuman and other deities. Thousands of monkeys roam freely here, adding a unique charm to the site. Pilgrims and tourists visit for spiritual rituals, photography, and to enjoy the natural setting and mountain views."
  },
  {
    "title": "Chokhi Dhani",
    "description": "Chokhi Dhani is a cultural village resort offering a complete Rajasthani experience with traditional food, folk dances, puppet shows, camel rides, and craft exhibitions. Visitors can explore recreated village streets, enjoy local cuisine, and witness Rajasthan’s rural lifestyle and hospitality. The immersive experience makes Chokhi Dhani a favorite for families, tourists, and cultural enthusiasts seeking an authentic glimpse of Jaipur’s traditions, festivals, and art forms."
  }
],




"services": [
  {
    "name": "Mumbai Jaipur Taxi",
    "description": "Mumbai Jaipur Taxi offers a reliable, comfortable, and long-distance travel service for passengers traveling between Mumbai and Jaipur. Covering an extensive route of over 1100+ km, this service is ideal for tourists, business travelers, family trips, and personal journeys requiring safe and hassle-free intercity transportation. With trained long-route drivers, spacious vehicles, door-to-door pickup, and flexible travel timings, passengers enjoy a smooth and stress-free highway journey. The taxis are equipped for long-hour comfort, ensuring a relaxed ride from Maharashtra to Rajasthan with complete convenience."
  },
  {
    "name": "Jaipur Cab from Mumbai",
    "description": "Jaipur Cab from Mumbai provides dependable and premium outstation travel for those heading toward Jaipur from Mumbai. Whether traveling for vacations, heritage tours, business events, or relocation, this service offers well-maintained vehicles, expert drivers, and transparent pricing. Passengers enjoy scenic routes, safe driving practices, and smooth connectivity along national highways, ensuring a memorable long-distance experience."
  },
  {
    "name": "One-Way Cab Mumbai Jaipur",
    "description": "One-Way Cab Mumbai Jaipur is an economical and convenient service perfect for passengers needing a single-drop journey to Jaipur. It eliminates the need to pay return charges, making it ideal for relocations, office transfers, family travel, or extended stays. Customers benefit from well-planned routes, clean vehicles, timely pickup, and safe driving throughout the long journey."
  },
  {
    "name": "Affordable Cab Mumbai Jaipur",
    "description": "Affordable Cab Mumbai Jaipur offers budget-friendly long-distance travel while maintaining high service standards. Designed for those who want economical intercity travel, this service ensures transparent fares, comfortable seating, fuel-efficient cars, and reliable chauffeurs. It’s the perfect choice for families, students, and budget-conscious travelers heading toward Jaipur."
  },
  {
    "name": "Best Taxi Mumbai Jaipur",
    "description": "Best Taxi Mumbai Jaipur provides top-tier quality travel with superior vehicles, courteous chauffeurs, and guaranteed punctuality. Favored by frequent travelers, families, and corporate passengers, this service focuses on safety, comfort, and reliability. Passengers enjoy smooth expressway travel, multiple rest stops, and uninterrupted connectivity across the long interstate route."
  },
  {
    "name": "SUV Cab Mumbai Jaipur",
    "description": "SUV Cab Mumbai Jaipur offers spacious, powerful, and comfortable SUVs ideal for long journeys. With extra legroom, strong air-conditioning, superior road grip, and enhanced luggage capacity, SUVs are the preferred choice for families and groups. These vehicles handle long highway stretches effortlessly, ensuring relaxed and smooth travel throughout the Mumbai–Jaipur route."
  },
  {
    "name": "Sedan Cab Mumbai Jaipur",
    "description": "Sedan Cab Mumbai Jaipur is perfect for passengers seeking an affordable yet comfortable long-distance travel solution. Sedans deliver excellent mileage, smooth suspension, and cozy interiors, making them ideal for solo travelers, couples, or small families. Passengers experience quiet cabin comfort and safe highway driving for the entire journey."
  },
  {
    "name": "Outstation Cab Mumbai Jaipur",
    "description": "Outstation Cab Mumbai Jaipur offers flexible travel solutions including round trips, one-way drops, multi-city tours, and long-duration rentals. Ideal for tourists exploring Rajasthan, business travelers attending events, or families visiting relatives, this service ensures dependable drivers, planned routes, and comfortable cars suited for extended travel."
  },
  {
    "name": "24×7 Mumbai Jaipur Taxi",
    "description": "24×7 Mumbai Jaipur Taxi ensures round-the-clock availability, making it ideal for late-night departures, early-morning trips, emergency travel, or last-minute trip planning. The service features trained night-driving chauffeurs, GPS-enabled cars, and instant booking confirmations for a safe and convenient journey at any hour."
  },
  {
    "name": "Corporate Cab Mumbai Jaipur",
    "description": "Corporate Cab Mumbai Jaipur caters to business professionals and companies requiring dependable intercity travel for meetings, conferences, and corporate visits. This service provides premium vehicles, punctual chauffeurs, spacious seating, and a smooth travel experience suitable for executive-level transportation."
  },
  {
    "name": "Premium Cab Mumbai Jaipur",
    "description": "Premium Cab Mumbai Jaipur offers luxury sedans, high-end SUVs, and chauffeur-driven premium travel for passengers who want superior comfort. With plush interiors, silent cabins, and VIP-level service, this luxury travel option is ideal for elite clients, family tours, and long-distance premium travel."
  },
  {
    "name": "Fast Cab Mumbai Jaipur",
    "description": "Fast Cab Mumbai Jaipur focuses on quick pickups, minimal waiting time, and optimized routing for faster intercity travel. Suitable for urgent meetings, emergencies, and last-minute travel plans, this service ensures efficient and safe long-distance travel using experienced drivers familiar with the fastest routes."
  },
  {
    "name": "Safe Taxi Mumbai Jaipur",
    "description": "Safe Taxi Mumbai Jaipur prioritizes passenger safety through sanitized vehicles, GPS tracking, disciplined driving, and vetted chauffeurs trained for long-distance routes. Ideal for women travelers, senior citizens, and families, this safety-focused service ensures a worry-free travel experience across state borders."
  },
  {
    "name": "Long Distance Cab Mumbai Jaipur",
    "description": "Long Distance Cab Mumbai Jaipur is designed for extended road journeys offering comfort-focused seating, smooth driving, climate-controlled cabins, and skilled highway chauffeurs. It is best suited for passengers who prefer long scenic road trips and want a fatigue-free travel experience over the lengthy Mumbai–Jaipur route."
  },
  {
    "name": "Family Cab Mumbai Jaipur",
    "description": "Family Cab Mumbai Jaipur provides a safe, comfortable, and family-friendly travel setup with spacious interiors, luggage capacity, and smooth suspension. With flexible stoppages, child-friendly driving, and safe speed control, families enjoy a relaxing and stress-free journey to Jaipur."
  },
  {
    "name": "Highway Cab Mumbai Jaipur",
    "description": "Highway Cab Mumbai Jaipur ensures efficient expressway and highway travel with drivers experienced in long-route driving. The vehicles are optimized for highway cruising, ensuring a stable ride, faster travel, and minimal fatigue across the long-distance route connecting Mumbai and Jaipur."
  },
  {
    "name": "Mumbai Jaipur Pickup Drop",
    "description": "Mumbai Jaipur Pickup Drop provides seamless point-to-point travel from any location in Mumbai to any destination in Jaipur. Ideal for hotel check-ins, office visits, relocations, and direct long-distance transfers, this service guarantees punctuality, safety, and a comfortable travel experience."
  }
],

"tableData": [
  ["Mumbai Jaipur Taxi", "Jaipur Cab from Mumbai"],
  ["One-Way Cab Mumbai Jaipur", "Affordable Cab Mumbai Jaipur"],
  ["Best Taxi Mumbai Jaipur", "SUV Cab Mumbai Jaipur"],
  ["Sedan Cab Mumbai Jaipur", "Outstation Cab Mumbai Jaipur"],
  ["24×7 Mumbai Jaipur Taxi", "Corporate Cab Mumbai Jaipur"],
  ["Premium Cab Mumbai Jaipur", "Fast Cab Mumbai Jaipur"],
  ["Safe Taxi Mumbai Jaipur", "Long Distance Cab Mumbai Jaipur"],
  ["Family Cab Mumbai Jaipur", "Highway Cab Mumbai Jaipur"],
  ["Mumbai Jaipur Pickup Drop", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Jaipur Taxi with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable Mumbai to Jaipur taxi services, ideal for long-distance travel, business trips, and comfortable family journeys to the Pink City."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly maintained taxis to ensure a smooth and relaxing ride to Jaipur."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long Highway Routes",
    "WhyChoosedescription": "Our expert drivers are highly experienced in long-route travel and familiar with the Mumbai to Jaipur highway, ensuring safe, smooth, and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Jaipur taxi journey stress-free and affordable."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel inquiries, and real-time route updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Long-Distance Trips",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customizable multi-day travel packages tailored to your Mumbai to Jaipur travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All taxis are thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making your Mumbai to Jaipur taxi journey smooth, comfortable, and worry-free."
  }
]






























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Jaipur taxi services?',
    answer: 'Yes, Shambhu Cabs provides dependable and comfortable Mumbai to Jaipur taxi services with professional long-distance drivers.',
  },
  {
    question: 'How can I book a Mumbai to Jaipur taxi with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for quick and hassle-free booking.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Jaipur taxi bookings?',
    answer: 'Shambhu Cabs offers a wide range of vehicles including sedans, SUVs, and luxury cars suitable for long interstate journeys to Jaipur.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Jaipur route?',
    answer: 'Yes, our drivers are licensed, trained, and experienced in handling long highway routes including Mumbai to Jaipur for a safe and smooth journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Jaipur taxi?',
    answer: 'Absolutely. You can select any pickup point in Mumbai and choose any preferred drop-off location in Jaipur.',
  },
  {
    question: 'Is the Mumbai to Jaipur taxi service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers 24x7 taxi booking services for Mumbai to Jaipur to match your travel convenience.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Mumbai to Jaipur taxi bookings?',
    answer: 'All vehicles are thoroughly sanitized, and our drivers follow strict hygiene and safety protocols throughout the journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Jaipur taxi bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and provide corporate billing options.',
  },
  {
    question: 'Is customer support available during the Mumbai to Jaipur journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Jaipur travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vinay Sharma',
    feedback: 'Our Mumbai to Jaipur journey with Shambhu Cabs was excellent. The driver was polite, experienced, and the car was very comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Rathore',
    feedback: 'Highly satisfied with the Mumbai to Jaipur taxi service. Clean vehicle, timely pickup, and smooth interstate travel experience.',
    rating: 5,
  },
];

















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Jaipur Taxi",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-jaipur-cab.jpg",
  "description": "Shambhu Cabs offers safe, reliable, and comfortable Mumbai to Jaipur taxi services for one-way or long-distance trips. Book sedans, SUVs, or premium cars for family travel, corporate trips, and highway journeys. Enjoy 24×7 availability, fast travel, and convenient pickup-drop from Mumbai to Jaipur.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "14200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-jaipur-taxi"
  }
};




  return (
    <div>
<Helmet>
  <title>Mumbai to Jaipur Taxi | Outstation & Corporate Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Jaipur taxi with Shambhu Cabs. Safe, affordable, and comfortable service for one-way or long-distance trips, family travel, corporate trips, and highway journeys. Available 24×7 with sedans, SUVs, and premium cars, including pickup-drop from Mumbai to Jaipur."
  />

  <meta
    name="keywords"
    content="Mumbai Jaipur Taxi, Jaipur Cab from Mumbai, One-Way Cab Mumbai Jaipur, Affordable Cab Mumbai Jaipur, Best Taxi Mumbai Jaipur, SUV Cab Mumbai Jaipur, Sedan Cab Mumbai Jaipur, Outstation Cab Mumbai Jaipur, 24×7 Mumbai Jaipur Taxi, Corporate Cab Mumbai Jaipur, Premium Cab Mumbai Jaipur, Fast Cab Mumbai Jaipur, Safe Taxi Mumbai Jaipur, Long Distance Cab Mumbai Jaipur, Family Cab Mumbai Jaipur, Highway Cab Mumbai Jaipur, Mumbai Jaipur Pickup Drop"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitojaipurtaxi;